export default __webpack_public_path__ + "static/media/guide.814937ff.png";